import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Table, Text, ActionLink, stickyHeader, stickyStyle } from '@custom-components';
import LocaleLink from '../../../../components/LocaleLink';
import { OverflowContainer, PulseWrapper, ProfileContainer, UserInfo } from '../List.styles';
import { userShape } from '../helperFunctions';
import { phoneFormatted } from '../../../../lib/utils';

const getOrgNames = (orgNames) => {
  if (orgNames.length === 0) return '-';
  if (orgNames.length <= 3)
    return orgNames.map((n, i) => (
      <div key={n}>
        {n}
        {i !== orgNames.length - 1 && ','}
      </div>
    ));
  return (
    <>
      <div>{orgNames[0]},</div>
      <div>{orgNames[1]},</div>
      <div>+ {orgNames.length - 2} Other Organizations</div>
    </>
  );
};
class UserTable extends PureComponent {
  resolveMessages = () => {
    const { messages } = this.props;
    return { ...UserTable.defaultProps.messages, ...messages };
  };

  renderRows = () => {
    const { data } = this.props;

    if (!data) return null;

    return data.map((user) => {
      const { id, firstName, lastName, emailAddress, phone, company, position, currentOrgName, customers, suppliers } =
        user;

      return {
        id,
        name: (
          <ProfileContainer>
            <UserInfo>
              {(company || position) && (
                <Text.CopyMini weight="bold" tagName="p" noMargins>
                  {company && <>{company}: </>}
                  {position}
                </Text.CopyMini>
              )}
              <Text.CopyBody weight="bold" tagName="p" noMargins>
                {firstName} {lastName}
              </Text.CopyBody>
              <Text.CopyParagraph noMargins>{currentOrgName}</Text.CopyParagraph>
            </UserInfo>
          </ProfileContainer>
        ),
        contactInfo: (
          <div>
            <Text.CopyParagraph tagName="span">{emailAddress}</Text.CopyParagraph>
            <br />
            <Text.CopyParagraph tagName="span">{phone ? phoneFormatted(phone) : ''}</Text.CopyParagraph>
          </div>
        ),
        customers: (
          <Text.CopyParagraph tagName="span" noMargins>
            {getOrgNames(customers.map((org) => org.name))}
          </Text.CopyParagraph>
        ),
        suppliers: (
          <Text.CopyParagraph tagName="span" noMargins>
            {getOrgNames(suppliers.map((org) => org.name))}
          </Text.CopyParagraph>
        ),
        actionLink: (
          <LocaleLink route="UserOverview" params={{ id: id.toString() }}>
            <ActionLink>
              <Text.HeadingSixth noMargins>View Details</Text.HeadingSixth>
            </ActionLink>
          </LocaleLink>
        )
      };
    });
  };

  render() {
    const { nameLabel, contactInfoLabel, actionHeaderLabel } = this.resolveMessages();
    return (
      <OverflowContainer>
        <PulseWrapper>
          <Table
            minTableWidth="100%"
            headerCellsConfig={{ roles: { width: '200px' }, actionLink: { style: stickyHeader } }}
            contentCellsConfig={{ actionLink: { style: stickyStyle } }}
            rows={[
              { id: 'name', label: nameLabel },
              { id: 'contactInfo', label: contactInfoLabel },
              { id: 'customers', label: 'Customer Organization(s)' },
              { id: 'suppliers', label: 'Supplier Organization(s)' },
              { id: 'actionLink', label: actionHeaderLabel }
            ]}
          >
            {this.renderRows()}
          </Table>
        </PulseWrapper>
      </OverflowContainer>
    );
  }
}

UserTable.propTypes = {
  data: PropTypes.arrayOf(userShape).isRequired,
  messages: PropTypes.shape({})
};

UserTable.defaultProps = {
  messages: {
    nameLabel: 'Name',
    contactInfoLabel: 'Contact Info',
    actionHeaderLabel: ''
  }
};

export default UserTable;
